import React from 'react'
import Text from '../../../../components/Text'
import Card from '../../../../components/Card'
import cx from 'classnames'
import styles from './CreateMediaCard.module.scss'
import { useTranslation } from 'react-i18next'
import NewMediaModalContent from '../CreateMediaModal/CreateMediaModal'
import { openModal } from '../../../../services/ModalService'

const CreateMediaCard: React.FC<{ onCreate: () => void }> = ({ onCreate }) => {
    const { t } = useTranslation(['settings'])

    const openCreateModal = () => {
        const content: JSX.Element = (
            <NewMediaModalContent onSubmit={() => onCreate()} />
        )
        openModal({
            heading: t('media.create_modal.heading'),
            content: content,
        })
    }

    return (
        <Card classes={cx(styles['card-wrapper'])}>
            <div
                className={cx(styles['card-inner-wrapper'])}
                onClick={() => openCreateModal()}
            >
                <div className={cx(styles['card-plus'])}>+</div>
                <Text>{t('media.create_modal.heading')}</Text>
            </div>
        </Card>
    )
}

export default CreateMediaCard
